import React from 'react';
import Lottie from 'lottie-react';
import { Link } from 'gatsby';
import Clock from "../../static/lotties/clock.json";

const HeroSection = () => {
  return (
    <section className='grid grid-col-1 lg:grid-cols-2 flex-1 max-w-[1050px] mx-auto py-10 lg:py-24 lg:space-x-4'>
      <div className='my-16'>
        <h1
          className='capitalize px-10 lg:px-0  text-[1.75rem] lg:text-[3.25rem] font-extrabold leading-[1.3] text-center lg:text-left mx-auto text-black'
          data-aos='fade-up'
          data-aos-delay='50'
          data-aos-duration='1000'>
          Groceries, Delivered fast in 20mins or less
        </h1>
        <p
          className='max-w-[420px] px-10 lg:px-0  mt-3 mb-2 text-sm leading-loose text-center mx-auto lg:text-left lg:ml-0 capitalize lg:text-[1.4rem] text-JeetarBlack'
          data-aos='fade-up'
          data-aos-delay='100'
          data-aos-duration='1000'>
          A new way of living and making every day better
        </p>
        <div
          className='flex justify-center px-5 lg:justify-start lg:px-0 mt-14 space-x-7 lg:space-x-11'
          data-aos='fade-up'
          data-aos-delay='150'
          data-aos-duration='1000'>
          <Link to='https://play.google.com/store/apps/details?id=com.jeetar.superapp'>
            <button className='h-[3.8rem] w-[8.9rem]  px-5 py-3 bg-black rounded-xl overflow-hidden'>
              <img
                className='object-cover '
                src={'/images/get-on-google.png'}
                alt='get on playstore'
              />
            </button>
          </Link>
          <Link to='https://apps.apple.com/us/app/jeetar/id1599147708'>
            <button className='h-[3.8rem] w-[8.9rem]  px-5 py-3 bg-black rounded-xl overflow-hidden'>
              <img
                className='object-cover '
                src={'/images/get-on-apple.png'}
                alt='get on appstore'
              />
            </button>
          </Link>
        </div>
      </div>
      <div className='flex items-center justify-center my-5 lg:my-0 clock-section'>
        <Lottie
          animationData={Clock}
          className='object-contain mx-auto w-72 lg:w-full'
          data-aos='fade-left'
          data-aos-delay='50'
          data-aos-duration='1000'
        />
      </div>
    </section>
  );
};

export default HeroSection;
